import { isArray } from 'util';
import { WarehouseMovement } from '../warehouse-movement';

export class WarehouseMovementBuilder {
  static fromJson(json) {
    return (json)
      ? new WarehouseMovement(
        json.hash,
        json.internalId,
        json.code,
        json.date,
        json.movementType,
        json.documentType,
        json.document,
        json.documentLine,
        json.quantity,
        json.deliveryNoteLine,
        json.deliveryNoteLineCode,
        json.deliveryNoteLineDescription,
        json.deliveryNoteLineQuantity,
        json.deliveryNoteLineCategory,
        json.deliveryNoteNumber,
        json.deliveryNoteProviderCode,
        json.deliveryNoteDate,
        json.deliveryNoteRegistrationDate,
        json.deliveryNoteProviderName,
        json.toolReference,
        json.deleted,
        json.selected
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(WarehouseMovementBuilder.fromJson) : [];
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/warehouse-movement.builder.ts